import { createFileRoute } from '@tanstack/react-router';

import {
  handleStripeReturn,
  validateStripeReturnSearch,
} from '@/features/payment-retry/services/stripe-return.service';
import { PaymentConfirmationPage } from '@/pages/payment-confirmation.page';

export const Route = createFileRoute('/_authenticated/payment_/confirmation')({
  validateSearch: validateStripeReturnSearch,
  beforeLoad: ({ search }) => {
    handleStripeReturn(search);
  },
  component: PaymentConfirmationPage,
});
